import { Component, OnInit } from '@angular/core';
import { OptionSelectorService } from '../services/option-selector.service';

@Component({
  selector: 'app-option-selector',
  templateUrl: './option-selector.component.html',
  styleUrls: ['./option-selector.component.css']
})
export class OptionSelectorComponent implements OnInit {


  list = [];
  opened = false;
  constructor(private optionSelector: OptionSelectorService) { }


  ngOnInit() {
    this.optionSelector.onOpen.subscribe((data) => {
      if (data.open) {
        this.list = data.list;
        this.opened = true;
      }
    })
  }

  send(l) {
    let index = this.list.findIndex((el) => {
      return el === l;
    });
    this.list.splice(index, 1);
    this.optionSelector.hide(l);
    this.close();
  }

  close(){
    this.opened = false;
  }
}
